import { render } from "./ExperimentComments.vue?vue&type=template&id=5848a3d4&scoped=true"
import script from "./ExperimentComments.vue?vue&type=script&lang=js"
export * from "./ExperimentComments.vue?vue&type=script&lang=js"

import "./ExperimentComments.vue?vue&type=style&index=0&id=5848a3d4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5848a3d4"]])

export default __exports__